import { useAuth } from "@/hooks/useAuth";
import { Navigate } from "react-router-dom";

interface SuperAdminRouteProps {
  children: React.ReactNode;
}

export function SuperAdminRoute({ children }: SuperAdminRouteProps) {
  const { isSuperAdmin } = useAuth();

  if (!isSuperAdmin()) {
    return <Navigate to="/index" replace />;
  }

  return <>{children}</>;
}
